<template>
  <div>
    <h4 class="toolbar-heading">Mode</h4>
    <v-radio-group v-model="radio">
      <v-radio color="primary" value="gop">
        <span slot="label" class="mode-label" style="color: #666;">
          Republican
          <!-- <span class="icon-republican" style="font-size: 18px; color: #FA3138;"></span> -->
        </span>
      </v-radio>
      <v-radio color="accent" value="dem">
        <span slot="label" class="mode-label" style="color: #666;">
          Democratic
          <!-- <span class="icon-democrat" style="font-size: 18px; color: #66ABCF;"></span> -->
        </span>
      </v-radio>
      <v-radio color="tertiary" value="god">
        <span slot="label" class="mode-label" style="color: #666;">God Mode</span>
      </v-radio>
    </v-radio-group>

    <h4 class="toolbar-heading">Scoreboard</h4>
    <div class="scoreboard-team">
      <div style="font-weight: 500; color: #FA3138;">REPUBLICAN</div>
      <div class="scoreboard-item">
        <span class="scoreboard-key">total spendings: </span>
        <span class="scoreboard-value">$255,887,147.61</span>
      </div>
      <div class="scoreboard-item">
        <span class="scoreboard-key">max spendings: </span>
        <span class="scoreboard-value">$255,887,147.61</span>
      </div>
      <div class="scoreboard-item">
        <span class="scoreboard-key">funding remaining: </span>
        <span class="scoreboard-value">$0.00</span>
      </div>
    </div>

    <div class="scoreboard-team">
      <div style="font-weight: 500; color: #66ABCF;">DEMOCRATIC</div>
      <div class="scoreboard-item">
        <span class="scoreboard-key">total spendings: </span>
        <span class="scoreboard-value">$325,290,701.53</span>
      </div>
      <div class="scoreboard-item">
        <span class="scoreboard-key">max spendings: </span>
        <span class="scoreboard-value">$325,290,701.53</span>
      </div>
      <div class="scoreboard-item">
        <span class="scoreboard-key">funding remaining: </span>
        <span class="scoreboard-value">$0.00</span>
      </div>
    </div>

    <h4 class="toolbar-heading">Actions</h4>
    <div style="text-align: center;">
      <v-btn color="primary" dark v-if="['republican', 'god'].includes(radio)">Maximize GOP wins</v-btn>
      <v-btn color="accent" dark v-if="['democratic', 'god'].includes(radio)">Maximize Dem wins</v-btn>
      <v-btn color="primary" dark v-if="['republican', 'god'].includes(radio)">Maximize GOP favorites</v-btn>
      <v-btn color="accent" dark v-if="['democratic', 'god'].includes(radio)">Maximize Dem favorites</v-btn>
      <v-btn color="warning" dark>Reset</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

const methods = {
  ...mapActions({
    setMode: 'calculator/setMode'
  })
}

const watch = {
  radio () {
    this.setMode(this.radio)
  }
}

export default {
  methods,
  watch,
  data () {
    return {
      radio: 'republican'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/CalculatorToolbar.vue